import getAPIPath from '../modules/api-location';

window.unfollowUserService = function(userId, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/user/follow/${userId}`,
    type: 'delete',
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },
  });
};


window.followUserService = function(userId, successFn) {
  const item = {};
  item.follow_user_id = userId;

  return $.ajax({
    url: `${getAPIPath}queryapi/user/follow`,
    type: 'post',
    data: JSON.stringify(item),
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};


window.unfollowClubService = function(clubId, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/club/follow/${clubId}`,
    type: 'delete',
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};

window.followClubService = function(clubId, successFn) {
  const item = {};
  item.follow_club_id = clubId;

  return $.ajax({
    url: `${getAPIPath}queryapi/club/follow`,
    type: 'post',
    data: JSON.stringify(item),
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};

window.unfollowTeamService = function(teamId, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/team/follow/${teamId}`,
    type: 'delete',
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};

window.followTeamService = function(teamId, successFn) {
  const item = {};
  item.follow_team_id = teamId;

  return $.ajax({
    url: `${getAPIPath}queryapi/team/follow`,
    type: 'post',
    data: JSON.stringify(item),
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};



// WEBPACK FOOTER //
// ./library/js/services/follow.service.js